import { useMemo } from "react";
import { useCategory } from "@/features/admin/queries/useCategories";
import type { CategoryTab } from "@/services/api/categories/types";

// Temporary: Company Structure tabs mockup until API is ready
const COMPANY_STRUCTURE_TABS: CategoryTab[] = [
  { value: "company-files", label: "Company Files", order: 0 },
  {
    value: "company-staff",
    label: "Company Staff",
    order: 1,
    isDefault: true,
    viewType: "company-staff",
  },
  {
    value: "job-postings",
    label: "Job Postings",
    order: 2,
    viewType: "job-postings",
  },
];

export function useCategoryTabsFromApi(categoryId?: string | number) {
  const { data: category } = useCategory(categoryId || "", {
    enabled: !!categoryId,
  });

  const tabs = useMemo(() => {
    if (category?.tabs && category.tabs.length > 0) {
      return category.tabs;
    }

    if (category?.name) {
      const categoryName = category.name.toLowerCase().trim();
      const normalizedName = categoryName.replace(/[_\s-]/g, "");

      if (
        categoryName === "company structure" ||
        categoryName.includes("company structure") ||
        categoryName === "company-structure" ||
        categoryName.includes("company-structure") ||
        normalizedName === "companystructure" ||
        normalizedName.includes("companystructure")
      ) {
        return COMPANY_STRUCTURE_TABS;
      }
    }

    return [];
  }, [category?.tabs, category?.name]);

  const defaultTab = useMemo(() => {
    if (tabs.length === 0) {
      return null;
    }

    const defaultTabFromConfig = tabs.find((tab) => tab.isDefault);
    if (defaultTabFromConfig) {
      return defaultTabFromConfig.value;
    }

    return tabs[0].value;
  }, [tabs]);

  return {
    tabs: tabs as CategoryTab[],
    defaultTab,
    isLoading: false,
  };
}
